/*

category: past-upcoming
{
      category: 'past',
      title: ,
      date: ,
      address: ,
      image: ,
},

{
      category: 'upcoming',
      title: ,
      date: ,
      address: ,
      image: ,
},

*/
export const seminarDetails = [
      {
      category: '',
      title: 'Rethinking Research Value in the Age of AI',
      date: 'February 3, 2026',
      address: '#300, 350 Legget Drive, Kanata, ON, K2K 2W7 (or Online)',
      image: 'ala abu alkheir eng.jpeg',
      },
      {
      category: '',
      title: 'Metrology Framework for Electric Vehicle Charging Stations in Canada',
      date: 'January 27, 2026',
      address: '#300, 350 Legget Drive, Kanata, ON, K2K 2W7 (or Online)',
      image: 'branislav eng.jpeg',
      },
      {
      category: '',
      title: 'ML-Based Reliability Assessor for Syndrome-Based Decoders for Linear Block Codes',
      date: 'January 16, 2026',
      address: '#300, 350 Legget Drive, Kanata, ON, K2K 2W7 (or Online)',
      image: 'claude eng.jpeg',
      },
      {
            category: 'past',
            title:'Seeing the Invisible - Building Situational Awareness in 5G Security',
            date: 'November 12, 2025',
            address: '#300, 350 Legget Drive, Kanata, ON, K2K 2W7 (or Online)',
            image: 'Cliff Ellement (eng).jpg',
      },
      {
            category: 'past',
            title: 'AI-driven innovation and technology solutions',
            date: 'October 9, 2025',
            address: '#300, 350 Legget Drive, Kanata, ON, K2K 2W7 (or Online)',
            image: 'Dr. Gwanggil Jeon (eng).jpg',
      },
      {
            category: 'past',
            title: 'Explainable and Robust AI for 6G',
            date: 'September 17th, 2025',
            address: '#300, 350 Legget Drive, Kanata, ON, K2K 2W7 (or Online)',
            image: 'seminar sinem eng.jpg',
      },
      {
            category: 'past',
            title: 'AI/ML, ISAC, and Network Digital Twin · 5G Network Modeling · Modeling 5G Non-Terrestrial Network (NTN) Links in MATLAB',
            date: 'September 16th, 2025',
            address: '#300, 350 Legget Drive, Kanata, ON, K2K 2W7 (or Online)',
            image: 'seminar mathwork eng.jpg',
      },



      {
            category: 'past',
            title: 'What happens after the PhD? Translating cybersecurity research into industrial impact',
            date: 'July 15th, 2025',
            address: '#300, 350 Legget Drive, Kanata, ON, K2K 2W7 (or Online)',
            image: 'Chen Seminar eng.jpg',
      },
      {
            category: 'past',
            title: 'Journey of an Entrepreneur Professor at the University of Ottawa',
            date: 'June 16th, 2025',
            address: '#300, 350 Legget Drive, Kanata, ON, K2K 2W7 (or Online)',
            image: 'handan eng.jpg',
      },
      {
            category: 'past',
            title: 'Evolving the Management of Future IIoT Networks and Industry 4.0/5.0 Systems - A tale of IT/OT convergence, DevOps, and Cloud Continuum Management',
            date: 'June 13th, 2025',
            address: '#300, 350 Legget Drive, Kanata, ON, K2K 2W7 (or Online)',
            image: 'luca eng.jpg',
      },
      {
            category: 'past',
            title: 'Driving Smarter: How AI Language Models Are Shaping the Future of Connected Vehicles',
            date: 'May 22, 2025',
            address: '#300, 350 Legget Drive, Kanata, ON, K2K 2W7 (or Online)',
            image: 'Dr Hina Seminar eng.jpg',
      },
      {
            category: 'past',
            title: 'Mathematical Programming and Large Language Models',
            date: 'May 7, 2025',
            address: '#300, 350 Legget Drive, Kanata, ON, K2K 2W7 (or Online)',
            image: 'Salimur - EN.jpg',
      },
      {
            category: 'past',
            title: 'Wireless Security for the Internet of Things: Device Authentication and Key Generation',
            date: 'April 30, 2025',
            address: '#300, 350 Legget Drive, Kanata, ON, K2K 2W7 (or Online)',
            image: 'seminar 1 eng.jpg',
      },
      
]
